import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { CustomerDataService } from 'src/app/shared/services/customer-data.service';
import { MoreInfoService } from 'src/app/shared/services/more-info.service';

@Injectable({
  providedIn: 'root'
})
export class GetSdkParamsService {
  private readonly BASE_URL = `${environment.baseUrlBiometric}/biometrics/get-sdk-params`;

  private httpOptions = {
    headers: new HttpHeaders({
      'x-adl-transaction-id':
        this.customerService.customerConditionData.transactionId,
      'x-adl-company-id': '0052',
      'x-adl-channel': 'PASIVO',
      'x-adl-biometric-token': '',
      'x-adl-product': 'CDT',
      'x-adl-document-number': this.customerService.customerData.numberDNI,
      Authorization: `Bearer ${this.customerService.customerConditionData.tokenaAuthorization}`
    }),
    params: { 'exclude-interceptor': 'true' }
  };
  constructor(
    private http: HttpClient,
    private customerService: CustomerDataService,
    private moreInfoService: MoreInfoService
  ) {}

  getParams(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.BASE_URL, {
      ...this.httpOptions,
      observe: 'response'
    });
  }
}
